import React, { useMemo } from 'react'
import { useEvents, SortDirectionEnum, Events_events_events } from '@modmd/data'
import { EventSessionDataList } from 'sharedComponents/EventSessionDataList'
import Datalist from 'components/Datalist'
import { useHistory, useParams } from 'react-router'
import { COMPANY_ROUTES, ROUTES } from 'client-portal/constants/routes'

type FilterType = {
  companyId?: string
  groupId?: string
  status: 'open' | 'closed'
}

interface Props {
  filter: FilterType
  title?: string
}

const getEvents = (status: 'open' | 'closed', data: Events_events_events[]) => {
  if (status === 'closed') {
    return data.filter((event) => event.finishedAt || !event.isActive)
  }
  if (status === 'open') {
    return data.filter((event) => !event.finishedAt && event.isActive)
  }
  return [] as Events_events_events[]
}

export const Events: React.VFC<Props> = ({ filter, title = 'Events' }) => {
  const history = useHistory()
  const params = useParams<{ companyId: string }>()
  const [testSessionsPage, setTestSessionsPage] = React.useState(1)

  const { data: eventsData, loading: isEventsLoading } = useEvents({
    filter: {
      companyId: filter.companyId,
    },
    page: Number(testSessionsPage) || 1,
    pageLength: 10,
    direction: SortDirectionEnum.DESC,
  })

  const events = useMemo(() => {
    if (eventsData?.events?.events) {
      return getEvents(filter.status, eventsData?.events?.events)
    }
    return []
  }, [eventsData?.events?.events, filter])

  return (
    <EventSessionDataList
      tableHeader={<Datalist.Title>{title}</Datalist.Title>}
      events={events || []}
      pagination={eventsData?.events?.pagination}
      isLoading={isEventsLoading}
      hasPaginationInFooter
      onPageChange={setTestSessionsPage}
      onRowClick={({ id }) =>
        history.push(`/${ROUTES.COMPANY}/${params.companyId}/${COMPANY_ROUTES.EVENTS}/${id}`)
      }
    />
  )
}
